import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const getFlatsArray = async (houseIds) => {
  const res = await request.get(
    `/Request/houses_flats_array`,
    {
      houseIds,
    },
    'Не удалось загрузить квартиры/офисы',
    []
  );
  return res;
};

export const useFlatsArray = (houseIds, options) =>
  useQuery(['flats', houseIds], () => getFlatsArray(houseIds), {
    enabled: Boolean(houseIds),
    ...options,
  });

export default useFlatsArray;
